import { Injectable, OnInit } from "@angular/core";
import { StorageService } from "./storage.service";
import { RoleType } from "../models/user.model";
import { ClaimModel } from "../models/role.model";
import { parseJwt } from "../utilities/jwt-utilities";

@Injectable()
export class ClaimsService {

    constructor(private storageService: StorageService) {}

    private hasCognitoGroup(name: string): boolean {        
        const groups = this.getGroups();
        let hasGroup = false;        
        if (groups && groups.find(g => g === name)) {
            hasGroup = true;
        }
        return hasGroup;
    }

    isSuperUser(): boolean {
        return this.hasCognitoGroup(RoleType.Superuser);
    }

    getGroups(): any {
        const token = parseJwt(this.storageService.getItem('token'));
        const groups = token['cognito:groups'];
        return groups;
    }

    /*
    * Although this property is called from a few places in the code, everywhere
    * it is used appears to be obselete, unused code. It would be interesting
    * to get some background on this!
    */
    get userId(): string {
        const user = JSON.parse(this.storageService.getItem('user'));
        return user.username;
    }

    isAdmin(): boolean {
        return this.hasCognitoGroup(RoleType.Admin);
    }

    hasBillingFeature(): boolean {
        return this.hasCognitoGroup('Billing');
    }

    hasConsumptionFeature(): boolean {
        return this.hasCognitoGroup('Consumption');
    }

    hasPaygFeature(): boolean {
        return this.hasCognitoGroup('PayAsYouGo');
    }

    hasPaygUpdateFeature(): boolean {
        return this.hasCognitoGroup('PayAsYouGoUpdate');
    }   
    hasClientFeature(): boolean {
        return this.hasCognitoGroup('Client');
    }   
    hasCamFeature(): boolean {
        return this.hasCognitoGroup('CAM');
    }   

    hasAnyClaims(): boolean {        
        const groups = this.getGroups();
        return groups && groups.length > 0;
    }

    private createGroup(name: string) {
        return {
            "key": "cognito:groups",
            "value": name
        };
    }

    getAsKeyValue(): ClaimModel[] {
        const output = [];
        if (this.isSuperUser()) output.push(this.createGroup(RoleType.Superuser));
        if (this.hasClientFeature()) output.push(this.createGroup('Client'));
        if (this.isAdmin()) output.push(this.createGroup(RoleType.Admin));
        if (this.hasCamFeature()) output.push(this.createGroup('CAM'));
        if (this.hasConsumptionFeature()) output.push(this.createGroup('Consumption'));
        if (this.hasBillingFeature()) output.push(this.createGroup('Billing'));
        if (this.hasPaygFeature()) output.push(this.createGroup('PayAsYouGo'));

        const user: any = JSON.parse(this.storageService.getItem("user"));
        if (user) {
            output.push({
                key: "name",
                value: user.name
            });
        }

        return output;
    }
}
